import axios from "axios";

export class FileUploadService {
    public async uploadImageAsync(model: any, field: string) {
        let success = true;

        try {
            if (model['file_to_upload'] != null) {
                const formData = new FormData();
                formData.append('file', model['file_to_upload']);
                formData.append('path', field);
    
                const file = await axios.post('uploadImage', formData);
                if (file?.status == 200)
                {
                    model[field] = file.data;
                    delete model['file_to_upload'];
                }
                else
                {
                    return false;
                }
            }
            
        } catch (error) {
            return false;
        }

        return success;
    }
}